<template>
  <div class="flex flex-col gap-2 bg-white rounded-lg">
    <textarea
      v-model="inputValue"
      :placeholder="placeholder"
      :rows="rows"
      :maxlength="maxlength"
      class="rounded-md border-[1px] border-solid border-neutral50 p-2 w-full max-h-96 resize-y focus:outline-none focus:ring-1 focus:ring-primary30 focus:border-primary30 text-textPrimary"
    ></textarea>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

const props = withDefaults(
  defineProps<{
    modelValue: string
    placeholder?: string
    rows?: number
    /** Limite de caracteres (atributo nativo); ausente = sem limite. */
    maxlength?: number
  }>(),
  {
    rows: 8
  }
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const inputValue = ref(props.modelValue)

watch(inputValue, (val) => {
  emit('update:modelValue', val)
})

watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal !== inputValue.value) {
      inputValue.value = newVal
    }
  }
)
</script>
